import React from 'react';
import PropTypes from 'prop-types';
import { Flex, FlexItem } from 'core/layout';
import { ArrowRight, Mail } from 'core/icons';
import { Button } from 'elements';
import { BackgroundImg } from 'elements/util';
import tulkojumi from 'utils/tulkojumi';
import pathWithRewrite from 'utils/pathWithRewrite';
import {
  StyledBanner,
  Container,
  ImgWrapper,
  Content,
  FABposition,
  StyledLink,
} from './styled';

class Banner extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    const { data: { links, image }, teksti, onPopup } = this.props;

    const linkItem = (item, index) => {
      const rewrite = pathWithRewrite(item, {
        key: 'location',
      });
      if (rewrite.location === null) { return false; }
      const external = rewrite.location.startsWith('http');
      const LinkComponent = external ?
        StyledLink.withComponent('a') :
        StyledLink;
      const linkProps = external ? {
        href: rewrite.location,
        target: rewrite.target,
      } : {
        to: item.location,
      }
      return (
        <li key={index}>
          <LinkComponent {...linkProps} onClick={() => {
            window.gtag && gtag('event', 'primary_menu_click', {
              event_category: 'navigation',
              event_label: linkProps.to || linkProps.href
            });
          }}>
            {item.label}
            <ArrowRight size='small' />
          </LinkComponent>
        </li>
      );
    };

    return (
      <StyledBanner role="banner">
        <ImgWrapper>
          <BackgroundImg src={(process.env.PUBLIC_URL || '') + image} />
        </ImgWrapper>

        <Container>
          <Flex justify='end'>
            <FlexItem basis={1/3} innerRef={c => this._column = c}>

              <Content>
                <nav>
                  <ul>
                    { links.map((item, i) => linkItem(item, i)) }
                  </ul>
                </nav>
              </Content>

            </FlexItem>

            <FABposition>
              <Button
                type='fab'
                icon={Mail}
                accent='secondary'
                // a11yLabel={tulkojumi(teksti, 'sazinaties')}
                title={tulkojumi(teksti, 'sazinaties')}
                data-query-id='js-feedback-button'
                onClick={() => {
                  onPopup && onPopup();
                }}
              />
            </FABposition>
          </Flex>
        </Container>
      </StyledBanner>
    );
  }
};

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/Sakums/components/Banner/Banner.jsx